import React from "react";
import styled from "styled-components";
import { FontSize } from "@themes/Fonts";

const ALL_DAY_EVENT_GUTTER_LABEL = "All day";

const GutterContainer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
`;

const GutterText = styled.span`
    font-size: ${FontSize.small};
    padding: 5px;
`;

function CalendarAllDayEventGutter() {
    return (
        <GutterContainer className={`calendar-all-day-event-gutter`}>
            <GutterText className={`calendar-all-day-event-gutter-text`}>{ALL_DAY_EVENT_GUTTER_LABEL}</GutterText>
        </GutterContainer>
    );
}

export default CalendarAllDayEventGutter;
